<div class="header">
    <h1 class="header-title">
        <mat-icon class="header-icon">import_export</mat-icon>
        {{data.title}}
    </h1>

    <lib-button (click)="cancel()" icon="close" color="none" textColor="muted" tooltip="{{'form.close' | translate}}">
    </lib-button>
</div>

<div class="list-dash content">
    <div class="list">
        <div class="title-search">
            <span>Liste des dashboards</span>
            <app-search-bar (searchText)="filterResults($event)"></app-search-bar>
        </div>

        <mat-accordion class="accordion" multi>
            <mat-expansion-panel *ngFor="let dashboard of filteredOptions" [ngClass]="{selected: isSelected(dashboard)}"
                (opened)="panelOpenState = true" (closed)="panelOpenState = false">
                <mat-expansion-panel-header>
                    <div class="header">
                        <mat-panel-title>
                            <mat-checkbox class="checkbox" (click)="$event.stopPropagation()"
                                (change)="toggleSelection(dashboard)"></mat-checkbox>
                            {{ dashboard.title }}
                        </mat-panel-title>

                        <mat-panel-description>
                            <p>{{getProjectAssociated(dashboard)}}</p>
                        </mat-panel-description>
                    </div>
                </mat-expansion-panel-header>

                <ul>
                    <p class="description" *ngIf="dashboard.description">
                        Description du rapport : {{ dashboard.description }}
                    </p>

                    <p>Liste des projets associés:</p>

                    <li *ngFor="let project of dashboard.projects">
                        <div class="project-item">
                            <p class="project-name">- {{ project.name }}</p>
                        </div>
                    </li>

                    <p *ngIf="dashboard.otherProjects > 0" class="project-name">
                        Autres projets : {{ dashboard.otherProjects }}
                    </p>
                </ul>
            </mat-expansion-panel>
        </mat-accordion>
    </div>
</div>

<div class="btn-action" mat-dialog-actions>
    <lib-button (click)="dismiss()" text="{{'form.cancel' | translate}}" color="outline" icon="close"></lib-button>

    <lib-button (click)="ok('duplicate')" color="primary" text="{{'form.duplicate' | translate}}"
        icon="content_copy"></lib-button>

    <lib-button (click)="ok('instantiate')" color="secondary" text="{{'form.instantiate' | translate}}"
        icon="link"></lib-button>
</div>